import { AddEditContactFormValues, VALID_PHONE_TYPES } from '../components';
import {
  Contact,
  ContactDto,
  Contacts,
  ContactsDto,
  ContactUpdateRequestDto,
} from '../types';

const mapContact = (contact: ContactDto, editable: boolean): Contact => ({
  id: contact.id,
  name: contact.name,
  address: contact.address,
  email: contact.email,
  groups: contact.groups,
  homePhone: contact.home_phone,
  workPhone: contact.work_phone,
  cellPhone: contact.cell_phone,
  notes: contact.notes,
  url: contact.url,
  title: contact.title ?? '',
  isEditable: editable,
  updatedAt: contact.updated_at,
});

export const mapContacts = (contacts: ContactsDto): Contacts => ({
  employerContacts: contacts.org_contacts.map((contact) =>
    mapContact(contact, false)
  ),
  userContacts: contacts.user_contacts.map((contact) =>
    mapContact(contact, true)
  ),
});

export const mapUserContactGroups = (contacts: Contacts): string[] =>
  contacts.userContacts
    .flatMap((contact) => contact.groups)
    .filter((group, index, self) => self.indexOf(group) === index); // a.k.a. Distinct

export const mapFormValuesToContactUpdateRequest = (
  formValues: AddEditContactFormValues,
  contact?: Contact
): ContactUpdateRequestDto => ({
  contact: {
    id: contact?.id,
    type: 'user',
    name: formValues.name,
    title: formValues.title,
    email: formValues.email,
    home_phone:
      formValues.phones?.find((phone) => phone.type === VALID_PHONE_TYPES.HOME)
        ?.phone ?? '',
    work_phone:
      formValues.phones?.find((phone) => phone.type === VALID_PHONE_TYPES.WORK)
        ?.phone ?? '',
    cell_phone:
      formValues.phones?.find(
        (phone) => phone.type === VALID_PHONE_TYPES.MOBILE
      )?.phone ?? '',
    groups: formValues.groups
      ?.filter((group) => group.checked)
      .map((group) => group.label ?? ''),
    url: formValues.website,
    notes: formValues.notes,
    address: formValues.address,
    updated_at: contact?.updatedAt,
  },
  modified_at: contact?.updatedAt,
});
